import { Modal } from '@design-system/components/modal/modal';
import { useEffect, useState } from 'react';
import { Input } from '@design-system/components/input/input';
import { Typography } from '@design-system/components/typography/typography';
import { _noop } from '@client/new/helpers/general';

export const ExtrasTabModal = (p: {
  mode: 'create' | 'edit';
  value: string;
  isOpen: boolean;
  onSubmit: (value: string) => void;
  onClose: () => void;
}) => {
  const [input, setInput] = useState<string>('Extras');

  useEffect(() => {
    setInput(p.value || 'Extras');
  }, [p.value]);
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Name your Extras"
      modalClassName="w-full md:max-w-[572px]"
      primaryCta={{
        caption: 'Save',
        onClick: () => p.onSubmit(input || 'Extras'),
      }}
      secondaryCta={{
        caption: 'Cancel',
        onClick: p.onClose,
      }}
      stretchCta
    >
      <Typography variant="body" fontWeight="normal">
        You are about to create a new space in your app that is ideal for
        promoting anything else you may be creating for your users. We suggest
        naming it, "Extras," "Links," or "Bonus."
      </Typography>
      <Typography variant="body" fontWeight="normal">
        Customize the name of this tab. You can always rename this later.
      </Typography>
      <Input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Extras"
        className="w-full"
        autoFocus
      />
    </Modal>
  );
};
